export default {
  pillars: [
    'COMMUNITY EQUITY AND JUSTICE',
    'STRONG, HEALTHY HOMES',
    'FINANCIAL RESILIENCY',
    'AGING IN PLACE',
    'CLIMATE JUSTICE'
  ]
};
